import React from 'react';

import { useTranslation } from 'react-i18next';

import { Logout } from '../../assets/icons/Logout';
import { localStorageSet } from '../../utils/localStorage';
import { ITrs } from '../../utils/types/types';
import Button from '../Button';

const SidebarBottom: React.FC = () => {
  const { t } = useTranslation();
  const trs: ITrs = t('trs', {
    returnObjects: true,
  });
  const logout = () => {
    localStorageSet('jwt', null);
    localStorageSet('user', false);
    localStorageSet('playPopUp', true);

    window.location.href = `${process.env.REACT_APP_URL_GAMEZONE}`;
  };

  return (
    <div>
      <Button
        color={'yellow'}
        handleClick={logout}
        startIcon={<Logout />}
        text={trs.logOut}
      />
    </div>
  );
};

export default SidebarBottom;
